import { render, staticRenderFns } from "./TemplateCreateWizardAllowManualCreate.vue?vue&type=template&id=243260e3&"
import script from "./TemplateCreateWizardAllowManualCreate.vue?vue&type=script&lang=ts&"
export * from "./TemplateCreateWizardAllowManualCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAutocomplete,VBtn,VDivider})
